module.exports = __webpack_public_path__ + "2bf5f1ab3fcaafc56bce1c69fedd1622.pdf";